import { SYSTEM_MODES } from '@silverfort-nodelibs/common/utils/system-mode-config';
import { PricingModules, SYSTEM_MODE } from '../../../../context/contexts/PricingModuleContext';
import { CATEGORIES } from '../../common/categories';
import { EnabledByModulesType, RequiredModuleState } from './types';

type CategoryDisplayConfig = {
    hiddenBySystemModes?: SYSTEM_MODE[];
    enabledByModules?: EnabledByModulesType;
};

export const HIDDEN_CATEGORIES_CONFIG: { [categoryId: string]: CategoryDisplayConfig } = {
    [CATEGORIES.PROTECTED_DOMAINS.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        }
    },
    [CATEGORIES.SILVERFORT_NODES.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        hiddenBySystemModes: [SYSTEM_MODES.SAAS, SYSTEM_MODES.SAAS_SUPPORT]
    },
    [CATEGORIES.AVAILABILITY_ZONES.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        },
        hiddenBySystemModes: [SYSTEM_MODES.SAAS, SYSTEM_MODES.SAAS_SUPPORT]
    },
    [CATEGORIES.MFA_TOKENS.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED,
            [PricingModules.PRIVILEGED_ACCESS_SECURITY]: RequiredModuleState.ON_PREM_ENABLED
        }
    },
    [CATEGORIES.USER_MANAGEMENT.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        }
    },
    [CATEGORIES.DESKTOP_APPLICATION.ID]: {
        enabledByModules: {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED,
            [PricingModules.PRIVILEGED_ACCESS_SECURITY]: RequiredModuleState.ON_PREM_ENABLED
        }
    },
    [CATEGORIES.INTEGRATIONS.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        }
    },
    [CATEGORIES.ADVANCED.ID]: {
        hiddenBySystemModes: [SYSTEM_MODES.SAAS]
    },
    [CATEGORIES.PRIVILEGED_ACCESS.ID]: {
        enabledByModules: {
            [PricingModules.PRIVILEGED_ACCESS_SECURITY]: RequiredModuleState.ON_PREM_ENABLED
        }
    },
    [CATEGORIES.NON_HUMAN_IDENTITIES.ID]: {
        enabledByModules: {
            [PricingModules.NHI_VISIBILITY]: RequiredModuleState.ON_PREM_ENABLED,
            [PricingModules.NHI_PROTECTION]: RequiredModuleState.ON_PREM_ENABLED
        }
    },
    [CATEGORIES.CUSTOM_INSIGHTS.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        }
    },
    [CATEGORIES.SILVERFORT_API.ID]: {
        enabledByModules: {
            [PricingModules.BASE_PLATFORM]: RequiredModuleState.ON_PREM_ENABLED
        }
    }
};
